module.exports = "/images/pin-sculpture-active.png?03fc0ad2fb3156b08d6a103092ae2351";